import { TableRecord } from '@/models/TableRecord'

export class FileRecord extends TableRecord {
  public name?: string
  public size?: number
  public type?: string
  public lastModified?: string
  public encodedFile?: string
}
